import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,    // 2 min - data considered fresh
      gcTime: 60 * 60 * 1000,       // 1 hour - keep in memory
      refetchOnWindowFocus: false,
      refetchOnMount: true,         // refetch solo se stale (non 'always' che causa loop)
      retry: 1,
    },
  },
});

// Prefetch today's matches immediately (before auth completes)
const _prefetchToday = () => {
  const now = new Date();
  const italyStr = now.toLocaleDateString('en-CA', { timeZone: 'Europe/Rome' });
  queryClient.prefetchQuery({
    queryKey: ['matches', italyStr],
    queryFn: async () => {
      const { data } = await (await import('axios')).default.get(`/api/matches?date=${italyStr}`, { timeout: 15000 });
      return data;
    },
    staleTime: 2 * 60 * 1000,
  });
};
_prefetchToday();
